module.exports = __webpack_public_path__ + "static/media/file-type-word.cb710a2f.png";